$(document).ready(function() {
    var elem = document.querySelector(".seccion-inicio");
    if (elem == null) {
        return;
    }


    $('#terrazasOwl').owlCarousel({
        margin: 0,
        nav: true,
        dots: false,
        loop: true,
        items: 4,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: false,
        navText: [
            '<img src="/assets/imagenes/extras/flechacarrusel.svg" alt="Anterior">',
            '<img src="/assets/imagenes/extras/flechacarrusel.svg" alt="Siguiente">',
        ],
        responsive : {
            0:{
                items: 1
            },
          767:{
              items: 2
          },
          1200:{
              items: 3
          },
          1600:{
              items: 4
          }

        }
    })
});
